import { useGetAssetPath } from '@gaming1/g1-core-web';

import { GamingAssetsContext } from './GamingAssetsContext';

export const useGetGamingAssetPath = () => useGetAssetPath(GamingAssetsContext);
